<template>
  <div class="o-card">
    <PageTitle
      :title="$t('cycleParameters.title')"
      :description="$t('cycleParameters.description')"
    />
    <CycleParameters></CycleParameters>
  </div>
</template>

<script>
import CycleParameters from "@/components/Settings/CycleParameters.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";

export default {
  components: {
    CycleParameters,
    PageTitle,
  },
};
</script>

<style></style>
